export interface ContactChannelSource {
    cellPhone?: string | null;
    phone1?: string | null;
    email1?: string | null;
}

export function preferredPhone(
    bestContact: ContactChannelSource | null,
    selfContact: ContactChannelSource | null,
): string | null {
    return (
        bestContact?.cellPhone ||
        bestContact?.phone1 ||
        selfContact?.cellPhone ||
        selfContact?.phone1 ||
        null
    );
}

export function preferredEmail(
    bestContact: ContactChannelSource | null,
    selfContact: ContactChannelSource | null,
): string | null {
    return bestContact?.email1 || selfContact?.email1 || null;
}
